import React from 'react';
import type ProjectSettingsServiceDeskCustomerPermissionsType from '@atlassian/jira-spa-apps-project-settings-service-desk-customer-permissions/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskCustomerPermissions = lazyForPaint<
	typeof ProjectSettingsServiceDeskCustomerPermissionsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-customer-permissions", jiraSpaEntry: "async-project-settings-service-desk-customer-permissions" */ '@atlassian/jira-spa-apps-project-settings-service-desk-customer-permissions'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskCustomerPermissions}
		pageId="project-settings-customer-permissions"
		shouldShowSpinner
	/>
);
